<template>
<span class="findings-output" :class="castType">
  <div v-if="isArray">
    <source-code-finding 
      v-if="scraper && scraper.scraper === 'Snitches\\Scrapers\\SearchSource'"
      :finding="value"
    />
    <p v-else v-for="(item, index) in value" :key="index"
      :class="getArrayItemClass(item)">
      {{ item }}
    </p>
  </div>
  <div v-if="isObject">
    <div class="mb-4" v-for="(value, key) in value" :key="key">
      <div class="pl-4">
        <p v-for="(value, key) in value" :key="key">
          <span>{{ key }}: {{ value }}</span>
        </p>
      </div>
    </div>
  </div>
  <div v-if="!isArray && !isObject">
    <p>{{ value }}</p>
  </div>
</span>  
</template>
<script>
import SourceCodeFinding from './SourceCodeFinding.vue'

export default {

  components: {
    SourceCodeFinding
  },
  
  props: {
    value: {
      required: true,
    },
    castType: {
      required: true
    },
    scraper: {
      type: Object,
      default: () => ({})
    },
    secondaryScrapers: {
      type: Array,
      default: () => ([])
    }
  },

  methods: {
    getArrayItemClass(item) {
      if(!isNaN(item)) return 'code-integer'
      return 'code-string'
    }
  },

  computed: {
    isArray() {
      return this.value instanceof Array
    },
    isObject() {
      return this.value instanceof Object && !this.isArray
    }
  }

}
</script>